import { render } from "./AgeContainer.vue?vue&type=template&id=7fbf7148&scoped=true"
import script from "./AgeContainer.vue?vue&type=script&lang=js"
export * from "./AgeContainer.vue?vue&type=script&lang=js"

import "./AgeContainer.vue?vue&type=style&index=0&id=7fbf7148&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbf7148"]])

export default __exports__